import { IDataTableColumn } from "nsitools-react";
import * as React from "react";

import { SearchTablePage } from "../../../../components";
import { useGlobalData } from "../../../../contexts";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { BreedersDogsApi, BreederDogsGridDto, BreederDogsSearch } from "../../../../api";
import { ERoutes } from "../../../../ERoutes";
import { Link } from "react-router-dom";

export interface IPersonBreederDogsPageProps {
  personId: number;
}

export const PersonBreederDogsPage: React.FunctionComponent<IPersonBreederDogsPageProps> = ({ personId }) => {
  const api = useApiService(BreedersDogsApi);
  const { t } = useTl();
  const { currentLanguage } = useGlobalData();

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        header: () => t(ETLCodes.CompleteName),
        fieldName: "firstName",
        render: (row: BreederDogsGridDto) => (
          <Link target="_blank" to={`${ERoutes.dog}/${row.dogId}/detail/view`}>
            {row.firstName} {row.kennelName ? row.kennelName : ""}
          </Link>
        ),
      },
      {
        header: () => t(ETLCodes.Breed),
        fieldName: "breed",
        render: (row: BreederDogsGridDto) => (
          <Link target="_blank" to={`${ERoutes.breeds}/${row.breedId}/detail/view`}>
            {row.breed}
          </Link>
        ),
      },
      {
        header: () => t(ETLCodes.Color),
        fieldName: "color",
        render: (row: BreederDogsGridDto) => (
          <Link target="_blank" to={`${ERoutes.color}/${row.colorId}/detail/view`}>
            {row.color}
          </Link>
        ),
      },
      {
        header: () => t(ETLCodes.Identification1),
        fieldName: "primaryIdentificationNumber",
      },
      {
        header: () => t(ETLCodes.Pedigree),
        fieldName: "pedigree",
      },
    ],
    [t]
  );

  const search = React.useCallback(
    (sObj) =>
      api.baseSearch(
        BreederDogsSearch.fromJS({ ...sObj, languageId: currentLanguage.languageId, personId: personId }).toJSON()
      ),
    [api, currentLanguage.languageId, personId]
  );

  return (
    <SearchTablePage
      title={t(ETLCodes.Dogs)}
      columns={columns}
      getCriteriasFunction={() => api.getSearchCriterias(true)}
      searchFunction={search}
      exportFunction={(sObj) =>
        api.exportXlsFile(
          BreederDogsSearch.fromJS({ ...sObj, languageId: currentLanguage.languageId, personId: personId })
        )
      }
      sortKeys={{ firstName: "ASC" }}
      withCard={false}
      criteriaSavePrefix={"PersonBreederDog"}
    />
  );
};
